/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
    /**
     * @author Nikola Lakovic
     * @namespace Tc.Module.ContactCollapsable
     * @class ContactCollapsable
     * @extends Tc.Module
     */
    Tc.Module.ContactCollapsable = Tc.Module.extend({

        /**
         * @method on
         * @param {Function} callback function
         * @return void
         */

        on: function(callback) {
            var mod = this,
                $ctx = mod.$ctx,
                $contact = $ctx.find('.contact'),
                $content = $ctx.find('.content').hide(),
                $link = $contact.find('a');
                $path = $ctx.closest('.modOrderOverlay').data('path');

            if (!$path) {
                $ctx.hide();
            } else {
                $ctx.siblings('.modOrderOverlayOrderButtons').addClass('irrelevant'); 

                // load content form help pages
                $content.load($path + ' .helpWidgetCF', function(response, status, xhr) {
                    if (status == "error") {
                        debug.log('Tc.Module.ContentCollapsable > no valid path entered', $path);
                        return;
                    } else {
                        $(this).addClass('loaded');
                    } 
                });
            }

            $contact.click(function() {
                if(!$content.hasClass('loaded')) {
                    $content.slideDown(200, $.proxy(mod.centerOverlay, mod));
                    setTimeout($.proxy(mod.centerOverlay, mod), 50);
                    setTimeout($.proxy(mod.centerOverlay, mod), 100);
                    setTimeout($.proxy(mod.centerOverlay, mod), 150);
                    $link.toggleClass('opened');
                } else {
                    $link.toggleClass('opened');
                    $content.slideToggle(200, $.proxy(mod.centerOverlay, mod));
                    setTimeout($.proxy(mod.centerOverlay, mod), 50);
                    setTimeout($.proxy(mod.centerOverlay, mod), 100);
                    setTimeout($.proxy(mod.centerOverlay, mod), 150);
                }
            });

            callback();
        },
        
        centerOverlay: function () {
            var mod = this;
            mod.fire('CenterOverlay');
        },
    });
})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ContactCollapsable.js
// module id = 132
// module chunks = 0